import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ContactComponent } from './contact/contact.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { ServicesComponent } from './services/services.component';
import { PrivacyPolicyComponent } from './policies/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './policies/terms-and-conditions/terms-and-conditions.component';
import { RefundPolicyComponent } from './policies/refund-policy/refund-policy.component';
import { CancellationPolicyComponent } from './policies/cancellation-policy/cancellation-policy.component';
import { Organizationalchart } from './organizationalchart/organizationalchart';
import { Mentor } from './mentor/mentor';


export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'home',
    component: HomeComponent,

  },
  {
    path: 'about-us',
    component: AboutusComponent,
  }, 

  {
    path: 'contact',
    component: ContactComponent,
  },
  {
    path: 'portfolio',
    component: PortfolioComponent,
  },
  {
    path: 'services',
    component: ServicesComponent,
  },
  {
    path: 'policies/privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'policies/terms-and-conditions',
    component: TermsAndConditionsComponent,
  },
  {
    path: 'policies/refund-policy',
    component: RefundPolicyComponent,
  },
  {
    path: 'policies/cancellation-policy',
    component: CancellationPolicyComponent,
  },
  {
    path: 'organizational-chart',
    component: Organizationalchart,
  },
  {
    path: 'mentor',
    component: Mentor,
  },
];



